export default "__VITE_ASSET__GtEZPRW6__"